import React from 'react';
import styled from 'styled-components';
import Loading from 'components/Loading';
import Typography from '../../../kingpin/atoms/Typography';

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 70px;
  gap: 8px;
`;

const LoadingSearch = () => (
  <WrapperDiv>
    <Loading />
    <Typography.Body type="Label 14">Searching</Typography.Body>
  </WrapperDiv>
);

export default LoadingSearch;
